import React, { useEffect, useState } from "react";
import MessageInfo from "../../common/MessageInfo";
import { useFetchSeoSettings } from "../../data/fetchSeoSettings";
import { SeoContext } from "../../data/seo/SeoContextProvider";
import SeoMainContainer from "../../data/seo/SeoMainContainer";
import SeoMetaTags from "../../data/seo/SeoMetaTags";
import { useHandleSeoSettings } from "../../data/seo/seoUtils";
import { getConfiguration } from "../../data/utils";
import { getLabel } from "../../data/labels";
import { useLayout } from "../../UISettingsProvider";

function PrematchNoEvents(props) {
    const layout = useLayout();
    const conf = getConfiguration();
    const cfgSeo = conf.seo;
    const seoContext = React.useContext(SeoContext);
    const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname,false,cfgSeo);

    const [label,setLabel] = useState(null);
    useHandleSeoSettings(seoSettingsState);

    useEffect(() => {
        if(seoSettingsState.data && seoSettingsState.data.seo ){
            setLabel(seoSettingsState.data.seo.label || '');
        }
    }, [seoSettingsState.data]);

    return (
        <>
            <SeoMetaTags />
            <div className={"griglia-centrale-sport col stringimento-sidebar " + layout.order.divCentrale} id="div-centrale">
            {label && 
                <div className="contenitore-schedine-sport">
                    <div className={"competizione-interna dueColonne dueColonne_Template_1 unaColonna"}>
                        <div id="primo-blocco-sport" className="sport-blocco primo-blocco-sport go-up-arrow-on-overflow no-margin tablesExpanded">
                            <div className="titolo-blocco-sport bg-nero bianco pointer">
                                <div className="nome-competizione-sport">
                                    <h1 className="grassetto">{label}</h1>
                                </div>
                            </div>
                            <MessageInfo message={getLabel('live_page.streams_schedule.no_matches')} />
                            <SeoMainContainer />
                        </div>
                    </div>
                </div>
            }
            </div>
        </>
    );
}

export default PrematchNoEvents;
